<div class="container">
  <div class="left_side">
    <app-table [columns]="columns" [lines]="transformedJourneys" (doActionParent)="doActionParent($event)"></app-table>
    <h2 class="empty_screen" *ngIf="!transformedJourneys.length">Todos los servicios ya tienen conductor</h2>
  </div>
</div>